import React, { useState } from "react";
import axios from "axios";
import { Button } from "reactstrap";

export const useItemOrdering = (items, setItems, endpoint) => {
  const [orderMessage, setOrderMessage] = useState({ error: "", success: "" });
  const [savingOrder, setSavingOrder] = useState(false);

  const moveItem = async (index, direction) => {
    const targetIndex = index + direction;
    if (savingOrder || targetIndex < 0 || targetIndex >= items.length) return;
    const previousItems = [...items];
    const reordered = [...items];
    [reordered[index], reordered[targetIndex]] = [reordered[targetIndex], reordered[index]];
    setItems(reordered);
    setSavingOrder(true);
    setOrderMessage({ error: "", success: "" });
    try {
      const response = await axios.put(endpoint, { ids: reordered.map((item) => item.id) });
      if (!response.data?.success) throw new Error(response.data?.errors?.message || "Failed to save order");
      setOrderMessage({ error: "", success: "Item order saved successfully" });
    } catch (error) {
      setItems(previousItems);
      setOrderMessage({ error: error.response?.data?.errors?.message || error.message || "Failed to save item order", success: "" });
    } finally {
      setSavingOrder(false);
    }
  };
  return { moveItem, orderMessage, savingOrder };
};

export const ItemOrderControls = ({ index, count, onMove, disabled }) => (
  <div style={{ display: "flex", gap: "6px", minWidth: "82px" }}>
    <Button type="button" size="sm" color="secondary" disabled={disabled || index === 0} onClick={() => onMove(index, -1)}>↑</Button>
    <Button type="button" size="sm" color="secondary" disabled={disabled || index === count - 1} onClick={() => onMove(index, 1)}>↓</Button>
  </div>
);

export const ItemOrderMessage = ({ message }) => <>
  {message.error && <div className="alert alert-danger" role="alert">{message.error}</div>}
  {message.success && <div className="alert alert-success" role="alert">{message.success}</div>}
</>;
